import { CreateElement, Rect } from "../.././MyHelpers";
import { Money } from "../../Money";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { DiamondSpinParams2 } from "./DiamondSpin2";

export class DiamondSpinJackpot implements Resourceful
{
	protected view:HTMLElement = null;
	protected resid:ResourceIdentifier = null;
	protected params: DiamondSpinParams2 = null;
	protected requiredToHit:number;
	protected jpName:string = "";

	protected jpFrame:HTMLElement = null;
	protected jpWin: HTMLElement = null;
	protected winContainer:HTMLElement [] = [];
	protected JpSequence:number = 0;

	constructor(jpName:string ,resid:ResourceIdentifier, params:DiamondSpinParams2, requiredToHit:number, Jp:number)
	{
		this.jpName = jpName;
		this.resid = resid.Add(this.jpName);
		this.params = params;
		this.requiredToHit = requiredToHit;
		this.JpSequence = Jp;

        this.view = CreateElement("div", {classes:[this.resid.Scope(),"JackpotContainer"],
            style:
            {
                width: "21%",
                height: "100%",
                display: "flex",
            }
        })
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager):void
	{
		this.PrepareJpFrame(resourceManager);
	}

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager):void 
	{
		this.JpFramesLoaded(resourceManager);
	}

	protected PrepareJpFrame(resourceManager: IWriteOnlyResourceManager):void
	{
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "jpFrame.png", this.resid.ScopedResourceName(["frame", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame1.png", this.resid.ScopedResourceName(["frame"+0, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame2.png", this.resid.ScopedResourceName(["frame"+1, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame3.png", this.resid.ScopedResourceName(["frame"+2, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame4.png", this.resid.ScopedResourceName(["frame"+3, "image"])));
	}

	protected JpFramesLoaded(resourceManager: IReadOnlyResourceManager):void
	{	
		for(let i = 0; i < this.requiredToHit ; i++)
		{
            this.jpFrame = CreateElement("div",{classes:[this.resid.Scope(),"jpFrame"], parentToAppend:this.view,
                style:
                {
                    width:"50%",
                    height: "50%",
                    backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["frame"+this.JpSequence, "image"])).CssBackground(),
                    backgroundRepeat : "no-repeat",
                    backgroundSize : "contain",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }
            });
            
            this.jpWin = CreateElement("div", {classes:[this.resid.Scope(),"jpWin"], parentToAppend:this.jpFrame,
                style:
                {
                    width :"70%",
                    margin: "10%",
                    height :"70%",
                    backgroundRepeat:"no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                }
            });
			this.winContainer.push(this.jpWin);
		}
	}

	public CenterOfFreeSpaceForDiamond(jpCount: number): Rect
	{
		//let jackpot:PickJackpot = this.pickJackpots.get(this.pickedAward.JackpotName);
		let freeSpotForJackpot:number = jpCount -1 ;
		if (freeSpotForJackpot >= this.winContainer.length)
		{
			freeSpotForJackpot = this.winContainer.length-1;
		}

		let W:HTMLElement = this.winContainer[freeSpotForJackpot];
		
		let winX:number =W.offsetLeft + this.view.parentElement.offsetLeft;// W.parentElement.parentElement.offsetLeft+ W.parentElement.parentElement.parentElement.offsetLeft;
		let winY:number = W.offsetTop + this.view.parentElement.offsetTop; //W.parentElement.offsetTop + W.parentElement.parentElement.offsetTop +W.parentElement.parentElement.parentElement.offsetTop;
		let winWidth:number = W.offsetWidth;
		let winHeight:number = W.offsetHeight;
		let winRect: Rect = new Rect(winX,winY,winWidth, winHeight);
		return winRect;
	}

	public JpFreeSpot(count:number):number
	{
		let freeSpot:number = count-1;
		if (freeSpot >= this.winContainer.length)
		{
			freeSpot = this.winContainer.length-1;
		}
		return freeSpot;
	}

	public WinContainer():HTMLElement[]
	{
		return this.winContainer;
	}

	public View():HTMLElement
	{
		return this.view;
	}
}

export interface DiamondSpinJackpotReward
{
	JackpotName:string;
	JackpotCount:number;
	WinAmount:Money;
}